module.exports = __webpack_public_path__ + "static/img/暂无头像.807e212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无头像.jpg
// module id = /kzG
// module chunks = 1